import * as React from "react";
import {Container, Row, Col, Button} from "react-bootstrap";
import {StaticImage} from "gatsby-plugin-image";
import "./style.scss";

export default class Intagrations extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        title: "Easily integrate with your stack",
        description: "Ready-to-use. API for web, iOS and Android",
    };

    render() {
        return (
            <Container className="Integrations outline-tabs">
                <Row>
                    <Col lg={9}>
                        <div className="h2 mb-4">{this.props.title}</div>
                        <p>{this.props.description}</p>
                    </Col>
                </Row>
                <Row className="logos">
                    <Col className="d-flex flex-wrap">
                        <a href="https://help.dashly.io/article/65" className="flex-column font14px slack" alt="slack">
                            <StaticImage src="./icons/slack.png" width={40} alt="slack" className=" me-3"/>
                            Slack
                        </a>
                        <a href="https://help.dashly.io/article/67" className="font14px email" alt="email">
                            <StaticImage src="./icons/email.png" width={40} alt="email" className="me-3"/>
                            Email
                        </a>
                        <a href="https://help.dashly.io/article/64" className="font14px telegram" alt="telegram">
                            <StaticImage src="./icons/telegram.png" width={40} alt="telegram" className="me-3"/>
                            Telegram
                        </a>
                        <a href="https://help.dashly.io/article/62" className="font14px zendesk" alt="zendesk">
                            <StaticImage src="./icons/zendesk.png" width={40} alt="zendesk" className="me-3"/>
                            Zendesk
                        </a>
                        <a href="https://help.dashly.io/article/66" className="font14px facebook" alt="facebook">
                            <StaticImage src="./icons/facebook.png" width={40} alt="facebook" className="me-3"/>
                            Facebook
                        </a>
                        <a href="https://help.dashly.io/article/1177" className="font14px calendly" alt="calendly">
                            <StaticImage src="./icons/calendly.png" width={39} alt="calendly" className="me-3"/>
                            Calendly
                        </a>
                        <a href="https://help.dashly.io/article/61" className="font14px zapier" alt="zapier">
                            <StaticImage src="./icons/zapier.png" width={40} alt="zapier" className="me-3"/>
                            Zapier
                        </a>
                        <a href="https://help.dashly.io/article/2351" className="font14px prestashop" alt="prestashop">
                            <StaticImage src="./icons/prestashop.png" width={40} alt="prestashop" className="me-3"/>
                            Prestashop
                        </a>
                        <a href="https://help.dashly.io/article/69" className="font14px woocommerce" alt="woocommerce">
                            <StaticImage src="./icons/woocommerce.png" width={40} alt="woocommerce" className="me-3"/>
                            Woocommerce
                        </a>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col>
                        <a href="https://help.dashly.io/category/5"> View All </a>
                    </Col>
                </Row>

                {
                  typeof window !== "undefined" ? window.location.pathname === '/' : '/ready-made-campaigns/'
                    &&
                    <div className='w-100 mt-3 d-flex mb-5 align-items-center'>
                        <Button
                            href="/panel/unauthorized/register"
                            variant="primary"
                            className="py-3 px-2 px-md-5 mt-4 mb-3 mb-md-0 mx-auto"
                        >
                            Start free trial
                        </Button>
                    </div>
                }


            </Container>
        );
    }
}
